export interface NicknameRecord {
    cashieringRequestId: string;
    cashieringSecRequestId: string;
    subAccountId: string;
    masterAccountId: string;
    nickname: string;
    type: string;
}

export interface NicknameRequest {
    nicknameRecord: NicknameRecord
}

export interface NicknameResponse {
    nickname: string
}

export const NicknameOperation = {
    Add: 'Add',
    Edit: 'Edit',
    Delete: 'Delete'
}
